import { microCopy } from "@bmi-digital/dxb-microcopies";
import React from "react";
import ButtonLink from "../../components/link/ButtonLink";
import createImageProps from "../../components/image/createImageProps";
import createVideoProps from "../../components/video/createVideoProps";
import type { CarouselHeroItem } from "@bmi-digital/components/carousel-hero";
import type { Context as SiteContext } from "../../components/Site";
import type { HomepageData } from "../home-page";
import type { Theme } from "@mui/material/styles";

export const getHeroItemsWithContext = (
  { getMicroCopy }: SiteContext,
  theme: Theme,
  slides: HomepageData["slides"]
): readonly CarouselHeroItem[] => {
  return slides.map(({ value: slide }, index) => {
    const hasPath = "path" in slide && !!slide.path;

    const callToAction =
      slide.collectionType === "promo" && slide.cta && slide.cta.length > 0 ? (
        <ButtonLink data={slide.cta[0]} hasBrandColours>
          {slide.cta[0].label}
        </ButtonLink>
      ) : hasPath ? (
        <ButtonLink
          data={{
            blockType: "internal-link-block",
            label: slide.title,
            linkedPage: { value: { path: slide.path } }
          }}
          hasBrandColours
        >
          {getMicroCopy(microCopy.PAGE_LINK_LABEL)}
        </ButtonLink>
      ) : undefined;

    return {
      title: slide.title,
      children: "subtitle" in slide ? slide.subtitle : undefined,
      hasUnderline: true,
      media:
        "featuredVideo" in slide && slide.featuredVideo
          ? createVideoProps(
              {
                ...slide.featuredVideo,
                "data-testid": "hero-video"
              },
              theme
            )
          : "featuredMedia" in slide && slide.featuredMedia
            ? createImageProps(
                {
                  ...slide.featuredMedia,
                  size: "cover",
                  "data-testid": "hero-image",
                  loading: index === 0 ? "eager" : "lazy"
                },
                theme
              )
            : undefined,
      cta: callToAction
    };
  });
};
